import { render, staticRenderFns } from "./GroupWill.vue?vue&type=template&id=70a8f5b6"
import script from "./GroupWill.vue?vue&type=script&lang=js"
export * from "./GroupWill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports